import React from "react";
import { BusinessPortalHeader, FlexContainer } from "src/components";
import PerksTable from "./components/PerksTable";
import pluralize from "pluralize";
import { customNames } from "src/utils/helpers";

const TablePage = ({
    user,
    perks,
    onHandleFilterByType,
    handleSearchChange,
    handleFilterByStatus,
    filterType,
    searchQuery,
    filterStatus,
    isFetching,
    allPerksChecked,
    handleCheckAllPerks,
    checkedPerks,
    handleCheckPerk,
    handleShowDeleteDialog,
    handleFormVisible,
    handleEditPerk
}) => {
    return (
        <FlexContainer maxWidth="98.625rem">
            <BusinessPortalHeader
                title="Perks"
                description={`Easily create and manage exclusive perks for ${pluralize(customNames.employees.toLowerCase())}, or ${pluralize(customNames.clients.toLowerCase())}. Use this feature to offer special rewards and gift perks, and customise benefits that align with your business. Track and update perks seamlessly to enhance user engagement and satisfaction.`}
            />

            <PerksTable
                user={user}
                perks={perks}
                onHandleFilterByType={onHandleFilterByType}
                handleSearchChange={handleSearchChange}
                handleFilterByStatus={handleFilterByStatus}
                filterType={filterType}
                searchQuery={searchQuery}
                filterStatus={filterStatus}
                isFetching={isFetching}
                allPerksChecked={allPerksChecked}
                handleCheckAllPerks={handleCheckAllPerks}
                checkedPerks={checkedPerks}
                handleCheckPerk={handleCheckPerk}
                handleShowDeleteDialog={handleShowDeleteDialog}
                handleFormVisible={handleFormVisible}
                handleEditPerk={handleEditPerk}
            />
        </FlexContainer>
    );
};

export default TablePage;
